/*
 * API
 * needLoading: { Boolean } 是否需要请求加载时的loading组件
 */
import service from '@/utils/request'

const info = params => {
  return service.get('/api/info', { params: params, needLoading: true, opacity: false, delay: 3000 })
}
const refresh = body => {
  return service.post('/api/refresh', body, { needLoading: true, opacity: true })
}
const purchase = body => {
    return service.post('/api/purchase', body, { needLoading: true, opacity: true })
}
const history = params => {
    return service.get('/api/history', { params: params, needLoading: true, opacity: true })
}
const draw = body => {
  return service.post('/api/draw', body, { needLoading: true, opacity: true })
}

const policyCheck = body => {
  return service.post('/api/policy_check', body, { needLoading: true, opacity: true })
}
export default {
  info,
  refresh,
  purchase,
  history,
  draw,
  policyCheck
}



// WEBPACK FOOTER //
// ./src/api/index.js